import api from './api';

export const getList = (params = {}) => {
  return api().get('/user', { params });
};

export const deleteUser = (params) => {
  const ids = (params || []).map((x) => x.user_id);
  return api().post(`/user/delete`, { ids });
};
export const getOptionsUser = (params) => {
  return api().get('/user/get-options', { params });
};

export const getDetail = (id) => {
  return api().get(`/user/${id}`);
};

export const changePassword = (userId, params) => {
  return api().put(`/user/${userId}/change-password`, params);
};

// đổi password của user check theo token
export const changeYourPassword = (params) => {
  return api().put(`/user/change-password`, params);
};

export const create = (params) => {
  return api().post(`/user`, params);
};
export const update = (id, params) => {
  return api().put(`/user/${id}`, params);
};

export const upload = (file, onUploadProgress) => {
  let formData = new FormData();

  formData.append('user', file);

  return api().post('/user/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const getListUserOpts = (params = {}) => {
  return api().get('/user', { params });
};


export const reviewDocuments = (id, params = {}) => {
  return api().put(`/user/${id}/review/documents`, { ...params })
};

